import type * as React from "react";

import { cn } from "../lib/utils";

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      data-skeleton=""
      className={cn(
        "relative isolate overflow-hidden rounded-sm bg-grayA-3",
        "before:absolute before:inset-0 before:-translate-x-full before:bg-linear-to-r before:from-transparent before:via-white/60 before:to-transparent dark:before:via-white/[0.06]",
        "motion-safe:before:animate-[teral-shimmer_1.8s_ease-in-out_infinite]",
        className,
      )}
      {...props}
    />
  );
}
